import type { IconData } from '@stacksjs/iconify-core'

export const coffeeShop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M53.71 26.872c0-3.16-2.561-5.477-5.721-5.477q-.216.002-.429.015v10.981q.213.016.429.017c3.16 0 5.721-2.377 5.721-5.537z\"/><path fill=\"currentColor\" d=\"M56.347.73H7.989A7.36 7.36 0 0 0 .63 8.089v48.358a7.36 7.36 0 0 0 7.359 7.359h48.358a7.36 7.36 0 0 0 7.359-7.359V8.089A7.36 7.36 0 0 0 56.347.73M17.893 17.837l29.668.007q.213-.01.429-.01c5.214 0 9.44 3.823 9.439 9.037c0 5.212-4.226 9.136-9.44 9.136q-.215-.001-.428-.011v1.392a5.297 5.297 0 0 1-5.296 5.296H23.189a5.297 5.297 0 0 1-5.296-5.296V17.836zM58.472 44.01a5.297 5.297 0 0 1-5.296 5.296H11.971a5.297 5.297 0 0 1-5.296-5.296v-.184h51.796z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default coffeeShop
